import { useVariants } from 'src/components/VariantsProvider/VariantsProvider';
import { FeatureFlag } from 'src/types/FeatureFlag';
import {
  useDevCycleAdapter,
  getIsDevCycleAvailable,
} from 'src/hooks/useDevCycleAdapter';

export interface FeatureFlagResult {
  value: boolean;
  isLoading: boolean;
}

export const useFeatureFlag = (flagKey: FeatureFlag): FeatureFlagResult => {
  const { variantIsActive, combinedVariants, hasOverrides } = useVariants();
  const isDevCycleAvailable = getIsDevCycleAvailable();

  const localVariantsReady = !!combinedVariants;
  const localValue = localVariantsReady ? variantIsActive(flagKey) : false;

  const { isInitialized, value: devCycleValue } = useDevCycleAdapter(
    flagKey.toLowerCase(),
    localValue
  );

  const hasLocalOverride =
    localVariantsReady &&
    hasOverrides &&
    combinedVariants[flagKey] !== undefined;

  // Priority: local overrides > DevCycle > local variants
  if (hasLocalOverride) {
    return {
      value: localValue,
      isLoading: false,
    };
  }

  if (!isDevCycleAvailable) {
    return {
      value: localValue,
      isLoading: !localVariantsReady,
    };
  }

  return {
    value: devCycleValue ?? localValue,
    isLoading: !isInitialized || !localVariantsReady,
  };
};
